import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iocnfont/icon.css'
import './assets/css/index.css'
import './assets/css/animate.min.css'
import '@/utils/global.js'
/* default-passive-events  控制台打印问题 */
import 'default-passive-events'
import VueCookies from 'vue-cookies'
import CreateAPI from 'vue-create-api'
Vue.use(CreateAPI)
Vue.use(VueCookies)
Vue.use(ElementUI);
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Print from 'vue-print-nb'
Vue.use(Print);
Vue.config.productionTip = false
import VueBarcode from "vue-barcode";

Vue.component('barcode', VueBarcode);

// 针对 el-input做的限制，只能输入正整数
Vue.directive('int', {
  bind: function (el) {
    const input = el.getElementsByTagName('input')[0]
    input.onkeyup = function (e) {
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, '')
      } else {
        input.value = input.value.replace(/[^\d]/g, '')
      }
      trigger(input, 'input')
    }
    input.onblur = function (e) {
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, '')
      } else {
        input.value = input.value.replace(/[^\d]/g, '')
      }
      trigger(input, 'input')
    }
  }
})

const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents')
  e.initEvent(type, true, true)
  el.dispatchEvent(e)
}


///* 滚动条 */
Vue.directive(
  "scroll-bottom", {
    bind(el, binding) {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      SELECTWRAP_DOM.addEventListener("scroll", function () {
        /**
         * scrollHeight 获取元素内容高度(只读)
         * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
         * clientHeight 读取元素的可见高度(只读)
         * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
         * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
         */
        const condition =
          this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (condition) {
          binding.value();
        }
      });
    },
  },
)

/* 全局指令  只能输入二位小数  */
Vue.directive("number_input", {
  bind(el, binding) {
    var wins_0 = /[^\d]/g //整数判断
    var wins_1 = /[^\d^\.]/g //小数判断
    var flag = true;
    var points = 0;
    var lengths = 0
    var remainder = 0
    var no_int = 0
    const target = el instanceof HTMLInputElement ? el : el.querySelector("input");
    target.addEventListener("compositionstart", e => {
      flag = false;
    });
    target.addEventListener("compositionend", e => {
      flag = true;
    });
    target.addEventListener("input", e => {
      setTimeout(function () {
        if (flag) {
          if (binding.value == 0) {
            if (wins_0.test(e.target.value)) {
              e.target.value = e.target.value.replace(wins_0, "");
              e.target.dispatchEvent(new Event("input")) //手动更新v-model值
            }
          }
          if (binding.value == 1) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true
            }
            if ((e.target.value.split('.')).length - 1 > 1) {
              points = true
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 1) {
                lengths = true
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false
            } else {
              no_int = true
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace(
                  '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                  ".") + 2)
              } else {
                e.target.value = e.target.value.replace(wins_0, "")
              }
              e.target.dispatchEvent(new Event("input"))
            }
          }


          if (binding.value == 2) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true
            }
            if ((e.target.value.split('.')).length - 1 > 1) {
              points = true
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 2) {
                lengths = true
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false
            } else {
              no_int = true
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace(
                  '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                  ".") + 3)
              } else {
                e.target.value = e.target.value.replace(wins_0, "")
              }
              e.target.dispatchEvent(new Event("input"))
            }
          }
        }
      }, 0)
    })
  }
})

/* 全局指令  宽度高度变化 */

Vue.directive("widthsize", {
  bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
    let width = '';
    // , height = ''
    function isReize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width) {
        // || height !== style.height
        binding.value(); // 关键
      }
      width = style.width;
      // height = style.height;
    }
    el.__vueSetInterval__ = setInterval(isReize, 500);
  },
  unbind(el) {
    clearInterval(el.__vueSetInterval__);
  }
})

// 注册mixin到全局
Vue.mixin({
  data() {
    return {};
  },
  beforeDestroy() {
    // this.$store.commit("WEBSOCKET_RFIDOFF");
  },
  created() {
    if (this.c_init &&
      typeof this.c_init == 'function') {
      this.c_init(this)
    }
  },
  mounted() {
    //组件加载完成后执行指定方法
    if (this.init &&
      typeof this.init == 'function') {
      setTimeout(() => {
        this.$nextTick(() => {
          this.init(this)
        });
      }, 0)
    }
  },
  methods: {
    global_detals(id) {
      this.$createDialog(this, {
        dialogConfig: { title: "资产详情预览", width: "840px" },
        namespace: "asset_list_global_details",
        whetherDestruction: true,

        assemblyConfig: {id},
      });
    },
    examine_details(row, type) {
      /*   {
          label: "领用",
          model: "receive",
        },
        {
          label: "退还",
          model: "refund",
        },

        {
          label: "借用",
          model: "borrow",
        },
        {
          label: "归还",
          model: "giveback",
        },
        {
          label: "变更",
          model: "change",
        },
        {
          label: "调拨",
          model: "allot",
        },
        {
          label: "维修",
          model: "repair",
        },
        {
          label: "处置",
          model: "dispose",
        }, */

      switch (type) {
        case "change":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产变更的详情",
              width: "860px"
            },
            namespace: "asset_change_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });

          break;

        case "receive":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产领用的详情",
              width: "860px"
            },
            namespace: "asset_receive_receiveEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });

          break;

        case "refund":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产退还详情",
              width: "860px"
            },
            namespace: "asset_receive_returnEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });

          break;

        case "borrow":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产借用详情",
              width: "860px"
            },
            namespace: "asset_borrow_borrowEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });

          break;

        case "giveback":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产归还详情",
              width: "860px"
            },
            namespace: "asset_borrow_returnEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;
        case "allot":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产调拨详情",
              width: "860px"
            },
            namespace: "asset_allot_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;

        case "repair":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产维修详情",
              width: "860px"
            },
            namespace: "asset_maintain_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;
        case "erepair":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产维修详情",
              width: "860px"
            },
            namespace: "asset_maintain_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;
        case "dispose":
          this.$createDialog(this, {
            dialogConfig: {
              title: "资产处置详情",
              width: "860px"
            },
            namespace: "asset_dispose_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;
      }
    },
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "await":
            str = "待审";

            break;

          case "pass":
            str = "同意";

            break;
          case "apass":
            str = "通过";

            break;
          case "cancel":
            str = "取消";

            break;
          case "refuse":
            str = "拒绝";

            break;
        }
      } else {
        switch (data) {
          case "pass":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "await":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "apass":
            str = "color:#42b983;background:#f0f9eb;";

            break;

          case "cancel":
            str = "color:#e0e0e0;background:#7c7c7c;";

            break;
          case "refuse":
            str = "color:#ffd0cc;background:#fa675c;";
            break;
        }
      }
      return str;
    },
    // 关闭弹出框
    closeDialog() {
      if (this.dialogVm) this.dialogVm.closeDialog();
      else if (this.$attrs.dialogVm) this.$attrs.dialogVm.closeDialog();
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  beforeDestroy() {
    this.$store.commit("WEBSOCKET_RFIDOFF");
  },
  created() {
    if (!window.localStorage.getItem("zichan_power")) {
      window.localStorage.setItem("zichan_power",this.$global.power||26);
    }
    if (window.sessionStorage.getItem('ZCTOKEN')) {

      if (window.sessionStorage.getItem('current_path')) {

        this.$nextTick(() => {
          this.$store.commit('current_path', JSON.parse(window.sessionStorage.getItem('current_path')))
        })

      }


      if (window.sessionStorage.getItem('menus')) {
        let menus = JSON.parse(window.sessionStorage.getItem('menus'))
        this.$store.commit('menulist_set', menus)

      }
      if (window.sessionStorage.getItem('userinfo')) {
        this.$store.commit('userInfo_ser', JSON.parse(window.sessionStorage.getItem('userinfo')))
      }

    }

  },mounted(){
    this.$store.commit("createSocket");

  },
  watch: {
    // 检测路由变化切换侧边栏内容

    '$route.matched': {
      handler(matched) {
        if (matched.length > 0) {
          // const _side = menu.state.header.filter(menu => menu.path === matched[0].path)
          // if (matched[0].path === "") {
          //   // this.$store.commit('d2admin/menu/asideSet', menu.state.header[1] ? menu.state.header[1].children : [])
          //   this.$store.commit('d2admin/menu/asideSet', menu.state.header)
          // } else
          //   this.$store.commit('d2admin/menu/asideSet', _side.length > 0 ? _side[0].children : [])
        }
      },
      immediate: true
    }
  }

}).$mount('#app')